import { getCookie } from 'react-simple-cookie-store'
import { isEmpty } from 'validator'
import { AccessToken } from './AccessToken'
import {} from 'jwt-decode'

// Add debugging
console.log('Loading getBearerToken module')

export const getBearerToken = () => {
  try {
    console.log('Getting bearer token')

    // Get access token
    let access: string = ''
    try {
      access = getCookie(AccessToken.Access) || ''
      console.log('Access token present:', access ? 'yes' : 'no')
    } catch (accessError) {
      console.error('Error getting access token for bearer:', accessError)
    }

    // Get temporary token
    let temporary: string = ''
    try {
      temporary = getCookie(AccessToken.Temporary) || ''
      console.log('Temporary token present:', temporary ? 'yes' : 'no')
    } catch (tempError) {
      console.error('Error getting temporary token for bearer:', tempError)
    }

    // Determine which token to use
    try {
      const result = isEmpty(access) ? temporary : access
      console.log(
        'Bearer token result:',
        result ? 'token available' : 'no token'
      )
      return result
    } catch (choiceError) {
      console.error('Error choosing bearer token:', choiceError)
      return ''
    }
  } catch (error) {
    console.error('Error getting bearer token:', error)
    // Log detailed error if available
    if (error instanceof Error) {
      console.error('Error details:', error.message, error.stack)
    }
    return ''
  }
}
